import { Store } from "redux";
import { SeoRenderer } from "../../../common/helpers/seo";

import ClosingClassroom from "./closed-classroom";

export default {
    component: ClosingClassroom,
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: "Musicators", allMessage, lang });
    },
};